import { components } from 'types/rest-schema';

export const SubjectDataListingReviewStatusTypes = {
    NotReviewed: 0,
    Reviewed: 1,
    Removed: 2,
} as const;

export type SubjectDataListingReviewStatusType =
    (typeof SubjectDataListingReviewStatusTypes)[keyof typeof SubjectDataListingReviewStatusTypes];

export type SubjectDataListingReviewInstance = components['schemas']['SubjectDataListingReview'];

export type SetDataListingReviewedDto = components['schemas']['SetDataListingReviewedDto'];
